// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"df1c1a3d","453":"6fc489d3","455":"192435fe"}[chunkId] + ".chunk.js";
};